const liveStreaming = {
  // 查询用户是否关注主播 客户端没推account，只能用用户ID --- 李健
  userFollow: `/authApi/user/live/follow`,
  // 查询用户基础信息 客户端没推account，只能用用户ID --- 李健
  userHeadImg: `/authApi/user/info`,
  // 获取直播间组件展示信息
  getLotteryShow: `/authApi/show/component/show/list`,
  // 获取直播间抽奖组件基础信息
  lotteryBasicInfo: `/authApi/show/lottery/basic/info`,
  // 获取抽奖组件 抽奖页信息
  lotteryDetail: `/authApi/show/lottery/detail`,
  // 开奖接口-结束记录
  endParticipate: `/authApi/show/lottery/end/participate`,
  // 抽奖中断
  lotteryInterrupt: `/authApi/show/lottery/interrupt`,
  // 锁定中奖信息
  lotteryOpen: `/authApi/show/lottery/open`,
  // 开启天选-记录开始参与抽奖数据
  startParticipate: `/authApi/show/lottery/start/participate`,
  // 抽奖组件抽奖信息保存
  lotteryInfo: `/authApi/show/save/lottery/info`,
  // 获取抽奖组件参与人员
  participateList: `/authApi/show/lottery/participate/list`,
  // 上报弹幕参与用户列表（开奖兜底）
  lotteryParticipants: `/authApi/show/component/lottery/participants`
};

export default liveStreaming;
